import React, { useState, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import _ from "lodash"; 

import DataTable from "../../components/DataTable";
import OptimiseMediaAction from "./action";
import { conditionalRowStyles } from "./rows.js";
import { columns } from "./columns.js";
import callApi from "../callApi";
import "./style.css";

const OptimiseMediaTableView = () => {
    const [allOffers, setAllOffers] = useState([]);
    const [pagination, setPagination] = useState({
        limit: 100,
        offset: 0
    });

    const [responseMessage, setResponseMessage] = useState(
        "There are no records to display"
    );
    const [pending, setPending] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const handleModalClose = () => setShowModal(false);
    const handleModalShow = () => setShowModal(true);

    const [offer, setOffer] = useState({});

    const [importDisabled, setImportDisabled] = useState(false);

    useEffect(() => {
        getMerchantOffers(pagination);
    }, [pagination]);

    const getMerchantOffers = (paginationData) => {
        setPending(true);
        let paginationLimit =
            paginationData && "limit" in paginationData ? paginationData.limit : 100;
        let paginationOffset =
            paginationData && "offset" in paginationData ? paginationData.offset : 0;
        let aggregator = 'optimise_media';
        let url = `${process.env.REACT_APP_API_URL}/v1/merchants/affiliate_merchant_offers`;
        url = url + `?aggregator=${aggregator}&limit=${paginationLimit}&offset=${paginationOffset}`;
        callApi(url)
            .then((json) => {
                if (json.data && json.data.affiliate_merchant_offers) {
                    setAllOffers(json.data.affiliate_merchant_offers);
                }
                if (json.status && json.status.message) {
                    setResponseMessage(json.status.message);
                }
                setPending(false);
            })
            .catch((err) => err);
    };

    const updateMerchantOffers = (importedOffer) => {
        let offers = _.cloneDeep(allOffers);
        for (let offer of offers) {
            if (offer.id.toString() === importedOffer.source_id) {
                offer.imported = true;
            }
        }
        setAllOffers(offers);
    };

    const onNextClick = () => {
        setPagination({
            limit: 100,
            offset: pagination.offset + pagination.limit
        });
    };

    const onPreviousClick = () => {
        let newOffset = pagination.offset - pagination.limit
        setPagination({
            limit: 100,
            offset: newOffset >= 0 ? newOffset : 0
        });
    };

    return (
        <div className="index-page">
            <h1 className="title">
                Optimise Media Offers
            </h1>
            <div className="mt-40">
                <DataTable
                    title={''}
                    columns={columns}
                    data={allOffers ? allOffers : []}
                    noDataComponent={responseMessage}
                    progressPending={pending}
                    onRowClicked={(row) => {
                        if (!row.imported) {
                            setOffer(_.cloneDeep(row));
                            handleModalShow();
                        }
                    }}
                    conditionalRowStyles={conditionalRowStyles}
                />
            </div>
            <div className="index-container">
                <button 
                    className="index-button"
                    onClick={onPreviousClick}
                    disabled={pagination.offset <= 0}>
                        Previous
                </button>
                <button 
                    className="index-button"
                    onClick={onNextClick}>
                        Next
                </button>
            </div>
            <Modal show={showModal} onHide={handleModalClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Selected Optimise Media Offer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OptimiseMediaAction 
                        optimiseMediaOffer={offer}
                        handleModalClose={handleModalClose}
                        setImportDisabled={setImportDisabled}
                        updateMerchantOffers={updateMerchantOffers} />
                </Modal.Body>
                <Modal.Footer>
                    <button 
                        form="optimise-media"
                        type="submit"
                        className="blue-button"
                        disabled={importDisabled}>
                            Import
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default OptimiseMediaTableView;